import React, { useEffect } from "react";
import places from "../data/places.json";

function Projects() {
  const projects = places;
  useEffect(()=>{
    const hash = window.location.hash;
    if (hash) {
    const id = hash.replace("#", "");

    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block:"center" });
      }
    }, 200);
  }
  },[]);
  
  const Card = ({name,img,id,tag}) => (
    <article id={`project-${id}`} className={`bg-secundario rounded-lg overflow-hidden flex flex-col justify-between`}>
      {/* <img src={img} alt={`${name}`} className="object-cover w-full h-[400px] outline outline-2 outline-primario" /> */}
      <span className="m-4 text-4xl font-bold h-[150px] flex justify-center items-center bg-primario text-secundario rounded-md">
        ILD 
      </span>
      <h3 className="text-xl font-bold font-primaria text-primario p-4">
        {name}
      </h3>
      <div className="flex flex-row gap-4 px-4 pb-8">
        {tag ? (
          tag.split("-").map((value) => (<span className="text-xs py-1 px-3 outline outline-2 outline-primario text-primario rounded-full font-bold font-primaria">{value.trim()}</span> ))
        ) : ("")}
      </div>
      {/* <a className="ml-auto w-max m-4 p-4 font-primaria font-bold text-secundario bg-primario" href={img} rel="nofollow noopener noreferrer" target="_blank">View project</a> */}
    </article>
  )
  return (
    <>
      <section className="relative h-[50vh] lg:h-[70vh] bg-primario py-20 px-6 lg:px-16 font-secundaria text-start overflow-hidden">
        <img
          src="https://innovativeld.com/assets/1912_anderson_rd.webp"
          alt="Civil Engineering & Land Development"
          className="absolute inset-0 w-full h-full object-cover opacity-50 blur-sm"
        />
        <div className="absolute inset-0 w-max lg:max-w-6xl mx-auto flex flex-col justify-center">
          <h1 className="text-4xl lg:text-8xl font-bold leading-tight mb-4 font-primaria text-secundario">
            Projects we have supported
          </h1>
          
        </div>
      </section>
      <section className="min-h-screen mx-auto py-20 px-10 lg:px-0">
        <div className=" lg:w-2/3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 mx-auto">
          {projects.map((value, index) => (
            <Card key={index} name={value.name} img={value.img} id={index+1} tag={value.tag}/>
          ))}

        </div>
      </section>
    </>
  );
}

export default Projects;
